import { render, staticRenderFns } from "./InformationPostureCard.vue?vue&type=template&id=e0caf910&scoped=true&"
import script from "./InformationPostureCard.vue?vue&type=script&lang=js&"
export * from "./InformationPostureCard.vue?vue&type=script&lang=js&"
import style0 from "./InformationPostureCard.vue?vue&type=style&index=0&id=e0caf910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0caf910",
  null
  
)

export default component.exports